import { Injectable } from "@angular/core";
import posthog from "posthog-js";
import { environment } from "@env";
@Injectable({
	providedIn: "root",
})
export class PosthogService {
	constructor() {
		if (!environment.ENABLE_MONITORING) {
			return;
		}

		posthog.init(
			environment.POSTHOG_API_KEY, // Replace with your actual API key
			{
				api_host: environment.POSTHOG_API_HOST, // or your self-hosted URL
				autocapture: true,
				capture_pageview: true,
				capture_pageleave: true,
				session_recording: {
					recordCrossOriginIframes: true,
				},
				rageclick: true,
			},
		);
	}

	// Identify user
	identify(userId: string, properties?: Record<string, any>) {
		if (!environment.ENABLE_MONITORING) {
			return;
		}
		posthog.identify(userId, properties);
	}

	// Capture custom events
	capture(eventName: string, properties?: Record<string, any>) {
		if (!environment.ENABLE_MONITORING) {
			return;
		}
		posthog.capture(eventName, properties);
	}

	// Reset user (on logout)
	reset() {
		if (!environment.ENABLE_MONITORING) {
			return;
		}
		posthog.reset();
	}

	// Set user properties
	setPersonProperties(properties: Record<string, any>) {
		if (!environment.ENABLE_MONITORING) {
			return;
		}
		posthog.setPersonProperties(properties);
	}

	captureError(error: Error, context?: Record<string, any>) {
		posthog.captureException(error, {
			$exception_message: error.message,
			$exception_type: error.name,
			$exception_stack: error.stack,
			...context,
		});
	}
}
